/**
 * F-180 A5 — gate protected routes behind a logged-in `user`.
 *
 * Bootstrapping → Spinner. Anonymous → friendly EmptyState with a
 * deep link to the bot (Mini App must be opened from inside TG to
 * complete the initData → JWT exchange). Authed → render children.
 */
import type { ReactNode } from 'react';
import { Button, EmptyState, Spinner } from '@/components/atoms';
import { useAuthStore } from '@/store';

const BOT_DEEP_LINK = 'https://t.me/Ola_Botardivna_bot';

interface Props {
  children: ReactNode;
}

export function RequireAuth({ children }: Props): JSX.Element {
  const user = useAuthStore((s) => s.user);
  const loading = useAuthStore((s) => s.isLoading);

  if (loading) return <Spinner center />;

  if (!user) {
    return (
      <EmptyState
        icon="verify"
        title="Увійди через бота"
        message="Цей розділ доступний тільки залогіненим. Відкрий Mini App у Telegram, щоб продовжити."
        actions={
          <a href={BOT_DEEP_LINK} rel="noopener" target="_blank">
            <Button variant="primary">Відкрити в Telegram</Button>
          </a>
        }
      />
    );
  }

  return <>{children}</>;
}
